/**
 * Destinos do hub de Administração — fonte única usada tanto pela página de
 * cards (`AdminHubPage`) quanto pelo breadcrumb do `AppShell`. Centralizar
 * aqui evita que os dois lugares saiam de sincronia: se um card existe, o
 * breadcrumb de volta pro hub também existe.
 *
 * `iconPath` é só o `d` de um <path> (stroke) — cada consumidor desenha o
 * <svg> do seu jeito (tamanho/cor), então o dado fica agnóstico de estilo.
 */
export interface AdminDest {
  to: string;
  label: string;
  desc: string;
  iconPath: string;
}

export const ADMIN_DESTS: AdminDest[] = [
  {
    to: '/servicos',
    label: 'Serviços',
    desc: 'Catálogo e preços',
    iconPath:
      'M21 13.255A23.9 23.9 0 0 1 12 15c-3.18 0-6.22-.62-9-1.745M16 6V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v1m4 6h.01M5 20h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2Z',
  },
  {
    to: '/equipe',
    label: 'Equipe',
    desc: 'Usuários e papéis',
    iconPath:
      'M17 20h5v-2a4 4 0 0 0-3-3.87M9 20H4v-2a4 4 0 0 1 3-3.87m10-3.13a4 4 0 1 0-4-4m-6 4a4 4 0 1 0 0 .01',
  },
  {
    to: '/consentimento',
    label: 'Consentimento',
    desc: 'Termos e LGPD',
    iconPath: 'M9 12l2 2 4-4m5.6 1A9 9 0 1 1 12 3a9 9 0 0 1 9.6 8Z',
  },
  {
    to: '/configuracoes',
    label: 'Configurações',
    desc: 'Clínica e preferências',
    iconPath:
      'M10.3 4.3a1 1 0 0 1 1.9 0l.3 1.2a1 1 0 0 0 1.5.6l1-.6a1 1 0 0 1 1.4 1.4l-.6 1a1 1 0 0 0 .6 1.5l1.2.3a1 1 0 0 1 0 1.9l-1.2.3a1 1 0 0 0-.6 1.5l.6 1a1 1 0 0 1-1.4 1.4l-1-.6a1 1 0 0 0-1.5.6l-.3 1.2a1 1 0 0 1-1.9 0l-.3-1.2a1 1 0 0 0-1.5-.6l-1 .6a1 1 0 0 1-1.4-1.4l.6-1a1 1 0 0 0-.6-1.5l-1.2-.3a1 1 0 0 1 0-1.9l1.2-.3a1 1 0 0 0 .6-1.5l-.6-1A1 1 0 0 1 6.8 5.5l1 .6a1 1 0 0 0 1.5-.6ZM12 12h.01',
  },
  {
    to: '/integracoes',
    label: 'Integrações',
    desc: 'WhatsApp, NFS-e, OpenAI',
    iconPath: 'M13 10V3L4 14h7v7l9-11h-7Z',
  },
];

/** Destino do hub cujo caminho casa com `pathname` (prefixo), ou undefined. */
export function adminDestForPath(pathname: string): AdminDest | undefined {
  return ADMIN_DESTS.find(
    (d) => pathname === d.to || pathname.startsWith(d.to + '/'),
  );
}
